import VueRecaptcha from 'vue-recaptcha'
import validationMixin from '../utils/validationMixin'
import simpleInputWrapper from '../utils/simpleInputWrapper'

export default {
  name: 'FormRecaptcha',
  components: {
    VueRecaptcha
  },
  mixins: [simpleInputWrapper, validationMixin],

  computed: {
    siteKey () {
      return window.envmap.VUE_APP_RECAPTCHA_SITE_KEY
    }
  },

  methods: {
    onVerify (response) {
      this.innerValue = response
      this.$emit('input', response)
      this.$emit('verify', response)
    },

    onExpired () {
      this.innerValue = null
      this.$emit('input', null)
      this.$emit('expired')
    },

    onError (error) {
      this.innerValue = null
      this.$emit('input', null)
      this.$emit('error', error)
    },

    reset () {
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset()
      }
      this.innerValue = null
    }
  }
}
